import script from "./SectionTop.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionTop.vue?vue&type=script&setup=true&lang=js"

import "./SectionTop.vue?vue&type=style&index=0&id=e1158750&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1158750"]])

export default __exports__